import script from "./DomainConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./DomainConfirmationModal.vue?vue&type=style&index=0&id=7adcd88f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7adcd88f"]])

export default __exports__